import { Component } from '@angular/core';
import { AuthRequestHomeboundComponent } from '@shared/component/auth-request/auth-request-homebound/auth-request-homebound.component';

@Component({
    selector: 'app-auth-request-homebound-commercial',
    templateUrl: './auth-request-homebound-commercial.component.html',
    styleUrls: ['../auth-request-homebound/auth-request-homebound.component.scss'],
    standalone: false
})
export class AuthRequestHomeboundCommercialComponent extends AuthRequestHomeboundComponent {}
